import { authenticatedFetch } from '../../api/request';

export type ConvertToCoachPayload = {
    accountCreationLocation?: string;
};

const convertToCoachAccount = async (payload: ConvertToCoachPayload, sessionToken: string) => {
    const path = '/v5/users/convertToCoach';
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' }
    };

    return authenticatedFetch(path, requestOptions, undefined, sessionToken);
};

export default convertToCoachAccount;
